module.exports = "../images/rates-contact@2x.jpg?v=0e56d09";